import { render } from "./CadastrarPagina.vue?vue&type=template&id=5ac7b1a2&scoped=true"
import script from "./CadastrarPagina.vue?vue&type=script&lang=js"
export * from "./CadastrarPagina.vue?vue&type=script&lang=js"

import "./CadastrarPagina.vue?vue&type=style&index=0&id=5ac7b1a2&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac7b1a2"]])

export default __exports__